import { Box } from "@mui/material";
import { PageLayout } from "../../components/PageLayout";
import theme from "../../theme";
import { Category } from "./Category";
import { SubCategory } from "./SubCategory";
import { useWindowSize } from "@reactuses/core";
import { useI18n } from "../../locales";
import userStorage from "../../utils/userStorage";

const { md } = theme.screen;

export const Sitemap = () => {
  const { t } = useI18n();
  const { width } = useWindowSize();
  const user = userStorage.get();
  const isInplabAdmin = user?.area === "00000" && user?.grade === 2;

  return (
    <PageLayout
      bodyHeight="calc(100vh - 242px)"
      bodyMinHeight="975px"
      subHeader={
        <Box
          sx={{
            height: width <= md ? "100px" : "130px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: width <= md ? "20px" : "40px",
            fontWeight: "700",
            color: theme.color.neutral_700,
          }}
        >
          {t.navigation.sitemap}
        </Box>
      }
    >
      <Box
        sx={{
          backgroundColor: theme.color.white,
          padding: width <= md ? "28px" : "32px",
          flexGrow: 1,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: width <= md ? "36px" : "48px",
          }}
        >
          <Category title={t.navigation.accidentControl}>
            <SubCategory title={t.navigation.accidentControl} path="/"/*"/control"*/ />
            {/* <SubCategory title="과거 감지내역 조회" path="/control/past" /> */}
          </Category>
          <Category title={t.navigation.detectionHistory}>
            <SubCategory title={t.navigation.detectionHistory} path="/detect-list" />
          </Category>
          <Category title={t.navigation.statistics}>
            <SubCategory title={t.navigation.statistics} path="/stastics" />
          </Category>
          <Category title={t.navigation.notice}>
            <SubCategory title={t.navigation.notice} path="/notice" />
          </Category>
          <Category title={t.navigation.management}>
            <SubCategory title={t.navigation.farmMachineryManagement} path="/mobile-list" />
            <SubCategory title={t.navigation.bigdata} path="/bigdata" />
            {isInplabAdmin && (
              <SubCategory title={t.navigation.userAccountManagement} path="/admin" />
            )}
            <SubCategory title={t.navigation.ownerManagement} path="/customer" />
            <SubCategory title={t.navigation.additionalRecipientManagement} path="/nok" />
          </Category>
          {isInplabAdmin && (
            <Category title={t.navigation.shopZone}>
              <SubCategory title={t.navigation.shopZoneMap} path="/shop-zone" />
              <SubCategory title={t.navigation.shopZoneAlarms} path="/shop-zone/alarms" />
            </Category>
          )}
        </Box>
      </Box>
    </PageLayout>
  );
};
